import React from "react";

export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-[#0B1D3A] text-white overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B1D3A]/70 via-[#0B1D3A]/80 to-[#0B1D3A]" />
        </div>
      )}
      <div className="absolute inset-0 papua-pattern-dark opacity-40" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {eyebrow && <div className="text-xs uppercase tracking-[0.22em] font-bold text-amber-400 mb-4">{eyebrow}</div>}
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tight max-w-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-lg text-slate-300 max-w-3xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
